import type { FC, ReactNode } from 'react'

interface UnitLabelProps {
    productId: string
    unit: string
    className?: string
}

const UnitLabel: FC<UnitLabelProps> = ({ productId, unit, className }): ReactNode => {
    return (
        <span className={className} data-mdlfy-cms={`products:${productId}:unit`}>
            {unit}
        </span>
    )
}

export default UnitLabel
